export default [
  {
    for: 'article',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: [
      'assetId',
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'cmsKilldate',
      'cmsLivedate',
      'seoTitle',
      'seoDescription',
      'seoImage',
      'documents',
      'linkId',
      'links',
      'ownedByChannel',
      'showMore',
      'subHeadline',
      'teaserHeadline',
      'teaserSubHeadline',
      'teaserText',
      'taxa',
      'recommendedArticles',
    ],
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
  },
  {
    for: 'artist',
    actions: {
      create: false,
      read: true,
      update: true,
    },
    excludedProperties: [
      'screenname',
      'themeType',
      'dateBirth',
      'dateDeath',
      'text',
      'showHome',
      'showSpotifyPlaylistGenerator',
      'visibleInList',
      'showNwlt',
      'channels',
      'ownedByChannel',
      'divisions',
      'alternativeLabels',
      'contactPeople',
      'stories',
      'taxa',
      'artistFunctions',
      'seoImage',
      'seoTitle',
      'seoDescription',
      'urlAliases',
    ],
    options: {
      canViewMetaData: false,
      canViewMmcRms: false,
      canViewVariants: false,
    },
  },
  {
    for: 'asset',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: [
      'subHeadline',
      'text',
      'ownedByChannel',
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'seoTitle',
      'seoDescription',
      'seoImage',
      'assetTokenConfigs',
    ],
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
  },
  {
    for: 'audioplayer',
    actions: {
      read: true,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'collection',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: [
      'text',
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
    ],
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
  },
  {
    for: 'content-item',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'coop-partner',
    actions: {
      read: true,
      create: true,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'link',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'live-event',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: [
      'text',
      'repertoire',
      'internalRemarks',
      'dgg',
      'secret',
      'tbc',
      'ownedByChannel',
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'seoTitle',
      'seoDescription',
      'seoImage',
    ],
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
  },
  {
    for: 'live-partner',
    actions: {
      read: true,
      create: true,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'media-embed',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: ['backgroundImage', 'backgroundColor', 'channels'],
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
  },
  {
    for: 'media-partner',
    actions: {
      read: true,
      create: true,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'mlp',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: [
      'cmsState',
      'isMultiArtistPage',
      'options.customCSS',
      'options.customHeader',
      'options.customJs',
      'options.customContainerClass',
      'options.customContainerId',
      'options.customOptions',
      'options.template',
      'sso',
      'shopifyStore',
      'shopifyHasCartPage',
      'template',
      'theme',
      'thumbnail',
      'vhost',
      'version',
    ],
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
  },
  {
    for: 'mlp-page',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'product',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: [
      'additionalCategories',
      'articles',
      'categories',
      'categoryId',
      'categoryId1',
      'categoryId2',
      'categoryId3',
      'categoryId4',
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'seoTitle',
      'seoDescription',
      'seoImage',
      'compilation',
      'country',
      'coverEmbargo',
      'dvdBonus',
      'dvdCountryCode',
      'dvdDuration',
      'dvdFsk',
      'dvdRatio',
      'dvdSystem',
      'hideTracks',
      'internationalLabel',
      'label',
      'mmcProductId',
      'ownedByChannel',
      'placedPrioritized',
      'prizeDe',
      'productElements',
      'productPhysCategoryId1',
      'productPhysId',
      'recommendedProducts',
      'recommendedTracks',
      'shortUrls',
      'soundEmbargo',
      'subheadline',
      'taxa',
      'trackEmbargo',
      'useProdElemConf',
      'videos',
      'voeTba',
    ],
    options: {
      canViewMetaData: false,
      canViewVariants: false,
    },
  },
  {
    for: 'teaser',
    actions: {
      read: true,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
  {
    for: 'trade-partner',
    actions: {
      read: true,
      create: true,
    },
    options: {
      canViewMetaData: false,
      canViewNavigation: false,
      canViewVariants: false,
    },
  },
];
